const normalizeDialableNumber = value => {
  const rawValue = String(value || '').trim();
  if (!rawValue) {
    return null;
  }

  const normalizedValue = rawValue.replace(/[^\d+*#]/g, '');
  const digitCount = (normalizedValue.match(/\d/g) || []).length;

  return digitCount ? normalizedValue : null;
};

const normalizeTransferSourceNumbers = (transfers, fallbackSourceNumber) =>
  Array.isArray(transfers)
    ? transfers.map(transfer => ({
        ...transfer,
        from:
          normalizeDialableNumber(transfer?.from) || fallbackSourceNumber || null,
      }))
    : [];

export const buildBrowserPhoneCdr = (cdr, context = null) => {
  const fallbackSourceNumber =
    normalizeDialableNumber(context?.sipExtension) ||
    normalizeDialableNumber(context?.ramal) ||
    normalizeDialableNumber(cdr?.SourceNumber) ||
    normalizeDialableNumber(context?.sipUsername) ||
    normalizeDialableNumber(context?.agentNumber) ||
    null;
  const fallbackDestinationNumber =
    normalizeDialableNumber(cdr?.DestinationNumber) ||
    normalizeDialableNumber(context?.number) ||
    normalizeDialableNumber(cdr?.Dst) ||
    null;
  const baseCdr = {
    ...cdr,
    SourceNumber: fallbackSourceNumber,
    DestinationNumber: fallbackDestinationNumber,
    Transfers: normalizeTransferSourceNumbers(
      cdr?.Transfers,
      fallbackSourceNumber
    ),
  };

  if (!context) return baseCdr;

  return {
    ...baseCdr,
    ChatwootAccountId: context.accountId || null,
    ChatwootAgentId: context.agentId || null,
    ChatwootAgentName: context.agentName || null,
    ChatwootContactId: context.contactId || null,
    ChatwootConversationId: context.conversationId || null,
    ChatwootTriggerSource: context.source || null,
  };
};
